export default "__VITE_ASSET__CHdZE2pp__"